(function(){
  'use strict';
  function boot(scope=document){
    scope.querySelectorAll('[data-variant-picker]').forEach(select=>{
      if(select.dataset.ready)return;select.dataset.ready='true';
      const update=()=>{
        const option=select.selectedOptions[0],form=select.closest('form'),button=form.querySelector('[data-add-button]');
        const section=select.closest('.product-detail'),price=section?.querySelector('[data-product-price]');
        if(price)price.textContent=option.dataset.price;
        if(button){button.disabled=option.disabled;button.querySelector('span').textContent=option.disabled?'Esaurito':'Aggiungi al carrello';}
        const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url.pathname+url.search);
      };select.addEventListener('change',update);
    });
    scope.querySelectorAll('form[data-product-form]:not(:has([data-config=name]))').forEach(form=>{
      if(form.dataset.ready)return;form.dataset.ready='true';const quantity=form.querySelector('[data-quantity]');
      function set(value){quantity.value=Math.min(99,Math.max(1,parseInt(value,10)||1));}
      form.querySelector('[data-qty-minus]')?.addEventListener('click',()=>set(Number(quantity.value)-1));
      form.querySelector('[data-qty-plus]')?.addEventListener('click',()=>set(Number(quantity.value)+1));
      quantity?.addEventListener('change',()=>set(quantity.value));
    });
    scope.querySelectorAll('[data-media-src]').forEach(btn=>{
      if(btn.closest('.product-layout')?.querySelector('[data-config=name]') || btn.dataset.ready)return;btn.dataset.ready='true';
      btn.addEventListener('click',()=>{
        const image=document.getElementById('gallery-image');if(!image)return;image.removeAttribute('srcset');image.src=btn.dataset.mediaSrc;image.alt=btn.dataset.mediaAlt || '';
        scope.querySelectorAll('[data-media-src]').forEach(b=>{b.classList.toggle('active',b===btn);b.setAttribute('aria-pressed',String(b===btn));});
      });
    });
    const subject=scope.querySelector('[data-contact-subject]');if(subject&&new URLSearchParams(location.search).get('argomento')==='progetto')subject.value='Un progetto 3D su misura';
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());else boot();
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();